import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiOriginalsResponse } from '@wix/da-papi-types';
import NotAllowed from '@wix/da-ds/pkg/Icons/16x16/NotAllowed';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import OrdersSectionTitle from '../../OrdersSectionTitle';
import OrdersList from '../OrdersList';
import OrdersByStatusEmptyState from '../../OrdersByStatusEmptyState';
import { STUDIO_ORDERS_CANCELED_STREAM } from '../../../../../constants';

const DeclinedOrdersList: React.FC = () => {
  const { t } = useTranslation();
  const { items: results, hasMore } = useStream<PapiOriginalsResponse>(
    STUDIO_ORDERS_CANCELED_STREAM.streamId,
    STUDIO_ORDERS_CANCELED_STREAM.streamThrottle,
    STUDIO_ORDERS_CANCELED_STREAM.streamConfig
  );
  if (results.length < 1) {
    return (
      <OrdersByStatusEmptyState
        headerTitle={t('studio.orders.status.canceled')}
        headerIcon={NotAllowed}
        text={t('studio.orders.status.canceled.emptyState')}
      />
    );
  }

  return (
    <OrdersList
      heading={
        <OrdersSectionTitle
          title={t('studio.orders.status.canceled')}
          icon={NotAllowed}
        />
      }
      results={results}
      hasMore={hasMore}
    />
  );
};
DeclinedOrdersList.displayName = 'DeclinedOrdersList';

export default DeclinedOrdersList;
